import React, { useState, useEffect } from 'react'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HC_map from 'highcharts/modules/map'
import worldMap from '@highcharts/map-collection/custom/world.geo.json'
import Exporting from 'highcharts/modules/exporting'
import OfflineExporting from 'highcharts/modules/offline-exporting'
import TaskManager from '../TaskManager/TaskManager.js'
import { EventEmitter } from "events";

Highcharts.maps["custom/world"] = worldMap

HC_map(Highcharts)
Exporting(Highcharts)
OfflineExporting(Highcharts)

const taskManagerEmitter = new EventEmitter();


const CountryRegistrationsDashboard = ({ legalManufacturerId = -1 }) => {

    const [userRole, setUserRole] = useState(window.userRole);
    const [loading, setLoading] = useState(true)
    const [selectedManufacturer, setSelectedManufacturer] = useState(legalManufacturerId);
    const [legalManufacturers, setLegalManufacturers] = useState([]);
    const [isLoadingLegalManufacturers, setIsLoadingLegalManufacturers] = useState(false);
    const [worldMapOptions, setWorldMapOptions] = useState(null)
    const [statusChartOptions, setStatusChartOptions] = useState(null)
    const [isShowingTaskManagerPopup, setIsShowingTaskManagerPopup] = useState(false);
    const [kpis, setKpis] = useState([]);
    const [taskCount, setTaskCount] = useState("-");



    const defaultDashboardData = {
        OpenSubmissions: "---",
        RegistrationsCount: "---",
        CertificateCount: "---",
        ChangeAssessmentsCount: "---",
        OperatorCount: "---",
        TotalCountries: "---",
        RegistrationsToBeExpiredCount: "---",
        FilesCount: "---",
    };

    const [dashboardData, setDashboardData] = useState(defaultDashboardData);

    useEffect(() => {
        loadDashboardData();
        loadLegalManufacturers();
        updateTaskCount();
    }, []);






    const loadDashboardData = async (legalManufacturer = selectedManufacturer) => {
        try {

            setDashboardData(defaultDashboardData);

            let url = "/umbraco/api/RIMSRegistrations/Dashboard/";
            if (legalManufacturer != -1)
                url += "?legalManufacturerId=" + legalManufacturer;

            const response = await fetch(url);
            let dashboardData = {};
            dashboardData = await response.json()

            if (Object.hasOwn(dashboardData, "RegistrationsCount")) {


                let updatedKpis = [
                    {
                        title: "Registrations",
                        value: dashboardData.RegistrationsCount,
                        icon: "fas fa-globe-americas",
                        url: "/your-medboard/country-registrations/registrations/",
                        trendValue: Math.round(dashboardData.RegistrationsCountVariability),
                    },
                    {
                        title: "Open Submissions",
                        value: dashboardData.OpenSubmissions,
                        icon: "fas fa-file-import",
                        url: "/your-medboard/country-registrations/submissions/",
                        trendValue: Math.round(dashboardData.OpenSubmissionsVariability),
                        valueColor: "#805ad5"
                    },
                    {
                        title: "Certificates",
                        value: dashboardData.CertificateCount,
                        icon: "fas fa-clipboard",
                        url: "/your-medboard/country-registrations/certificates/",
                        trendValue: Math.round(dashboardData.CertificateVariability),
                        valueColor: "#2b6cb0"
                    },
                    {
                        title: "Change Asssessments",
                        value: dashboardData.ChangeAssessmentsCount,
                        icon: "fas fa-clipboard-check",
                        url: "/your-medboard/country-registrations/change-assessments/"
                    },
                    {
                        title: "Operators",
                        value: dashboardData.OperatorCount,
                        icon: "fas fa-building",
                        url: "/your-medboard/country-registrations/operators/",
                        subtextColor: "#a0aec0"
                    }/*,
                    {
                        title: "Files",
                        value: dashboardData.FilesCount,
                        icon: "fas fa-file",
                        url: "/your-medboard/country-registrations/documents/",
                    }*/
                ];
        
                updatedKpis = updatedKpis.map(card => {

                    const hasTrend = card.trendValue !== undefined;

                    card.hasTrend = hasTrend;
                    card.subtextColor || "";
                    card.subtextIcon || "";
                    card.subtext || "";

                    if (hasTrend) {
                        if (card.trendValue > 0) {
                            card.trendColor = "#48bb78";
                            card.trendIcon = "fa-arrow-up";
                            card.trendText = `+${card.trendValue}% this month`;
                        } else if (card.trendValue < 0) {
                            card.trendColor = "#e53e3e";
                            card.trendIcon = "fa-arrow-down";
                            card.trendText = `${card.trendValue}% this month`;
                        } else {
                            card.trendColor = "#a0aec0";
                            card.trendIcon = "fa-minus";
                            card.trendText = "0% this month";
                        }
                    };

                    return card;
                });


                setKpis(updatedKpis);

                setDashboardData(dashboardData)
            }

        }
        catch (e) {
            console.error(e)
        }

        setLoading(false)
    }



    const loadLegalManufacturers = () => {


        let legalManufacturerRoleId = 1;

        let countsURL = "/umbraco/api/ProductRegistrationsApi/CompanyOperators?" +
            `search=&` +
            `roleId=${encodeURIComponent(legalManufacturerRoleId)}&`;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingLegalManufacturers(true);

        fetch(countsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setLegalManufacturers(result);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingLegalManufacturers(false);
            });

    }



    const changeLegalManufacturer = (changeLegalManufacturer) => {

        // change state

        setSelectedManufacturer(changeLegalManufacturer);

        // Reload dashboard numbers

        loadDashboardData(changeLegalManufacturer);

        // Change session also

        let url = "/umbraco/api/Compliance/LegalManufacturerSession/?legalManufacturerId=" + changeLegalManufacturer;

        let requestOptions = {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
            });


    }






    const updateTaskCount = () => {


        
        let url = "/umbraco/api/TaskManagerApi/Summary/?entityType=countryregistration";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                if (result.length) {

                    setTaskCount(result.find(r => r.TaskFor == "Company")?.Total);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
            });
    }

    


    
    const openTaskManagerForEntity = () => {

        let baseUrl = "/your-medboard/country-registrations/country-registrations-task-manager/?entityType=countryregistration&entityId=";

        window.location.href = baseUrl;

    }


    if (loading)
        return <LoadingSpinnerImage />

    return (

        <div style={{ fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif", width: "100%", margin: "0 auto", padding: "20px", backgroundColor: "#f7fafc", borderRadius: "12px" }}>

            {/* Breadcrumb */}

            <div style={{ marginBottom: "20px" }}>
                <p style={{ color: "#718096", fontSize: "12px", margin: 0, fontWeight: 500 }}>

                    <span style={{ color: "#4a5568", fontWeight: 600 }}>
                        Country Registrations
                    </span>

                </p>
            </div>

            {/* Header */}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", flexWrap: "wrap", gap: "20px" }}>

                <div>
                    <h2 style={{ margin: "0 0 5px 0", fontSize: "28px", fontWeight: 700, color: "#1a202c" }}>
                        Country Registrations Dashboard
                    </h2>
                    <p style={{ margin: 0, color: "#718096", fontSize: "14px" }}>
                        Global market access, registration lifecycle management, and workflows.
                    </p>
                </div>

                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>

                    <span className="task-action-btn pointer" onClick={() => openTaskManagerForEntity()}>
                        <i className="far fa-calendar-check"></i>
                        <span>Open Tasks</span>
                        <div
                            className={`task-count-badge ${taskCount > 0 ? "has-tasks" : "no-tasks"
                                }`}
                        >
                            {taskCount || "0"}
                        </div>
                    </span>
                    {isLoadingLegalManufacturers ?
                        <LoadingSpinnerImage />
                        :
                        <>
                            {selectedManufacturer != -1 ?
                                <button
                                    className="btn g-font-size-13"
                                    style={{ paddingRight: "12px", paddingLeft: "12px", lineHeight: "1.6rem", height: "35px", backgroundColor: "#f7f7f7", color: "#3477b4", border: "1px solid #3477b4" }}
                                    onClick={() => changeLegalManufacturer("-1")}
                                >
                                    <i className="far fa-times-circle g-mr-5"></i>
                                    Clear filter
                                </button>
                                : null}

                            <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 12px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                                <i className="fas fa-filter" style={{ color: "#a0aec0" }} />
                                <select value={selectedManufacturer} onChange={e => changeLegalManufacturer(e.target.value)} style={{ border: "none", background: "transparent", outline: "none", fontWeight: 600, color: "#4a5568", cursor: "pointer" }}>
                                    <option value="-1">
                                        All Legal Manufacturers
                                    </option>
                                    {legalManufacturers.map(x => (
                                        <option key={x.EstablishmentId} value={x.EstablishmentId}>
                                            {x.Establishment}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </>
                    }
                    {userRole === "Admin" ? (
                        <a
                            className="btn u-btn-blue g-font-size-13 g-pl-12 g-pr-12 g-pt-8 g-pb-8 g-ml-3 pull-right border-radius-20"
                            href="/your-medboard/country-registrations/registrations/?defaultOpenAddItemPopup=true"
                        >
                            <i className="fas fa-plus-circle" style={{ marginRight: "10px" }}></i>
                            Add registration
                        </a>
                    ) : (
                        <button
                            disabled
                                className="action-button add-task-button disabled-button" style={{ backgroundColor: "#c0c0c0" }} 
                            title="No permission. Check with your Admin." 
                        >
                            <i className="fas fa-plus-circle g-mr-5"></i>
                            Add registration
                        </button>
                    )}
                    

                </div>
            </div>

            {/* KPI GRID */}

            <div className="kpi-grid">

                {kpis.map(card =>
                    <a
                        key={card.title}
                        href={card.url}
                        className={`kpi-card ${card.extraClass || ""}`.trim()}
                    >
                        <span className="kpi-title">{card.title}</span>
                        <div className="kpi-value-row">
                            <i className={`${card.icon} kpi-icon`} />

                            <span
                                className="kpi-value"
                                style={card.valueColor ? { color: card.valueColor } : undefined}
                            >
                                {card.value}
                            </span>

                            {(card.hasTrend || card.trendText) && (
                                <span
                                    className="kpi-subtext"
                                    style={card.trendColor ? { color: card.trendColor } : undefined}
                                >
                                    {card.trendIcon && (
                                        <i className={`fas ${card.trendIcon}`} style={{ marginRight: '4px' }} />
                                    )}
                                    {card.trendText}
                                </span>
                            )}
                        </div>
                    </a>
                )}
            </div>
            {/* CHARTS */}

            <div style={{ display: "flex", flexWrap: "wrap", gap: "24px", marginBottom: "24px" }}>

                <div style={{ flex: 2, minWidth: "450px", background: "#fff", borderRadius: "12px", padding: "24px", border: "1px solid #e2e8f0" }}>


                        {/* Header */}
                        <div style={{ marginBottom: "20px", borderBottom: "1px solid #edf2f7", paddingBottom: "12px" }}>
                            <h3 style={{ margin: 0, fontSize: "14px", color: "#3182ce", fontWeight: 700 }}>
                                <i className="fas fa-map" style={{ marginRight: "8px" }} />
                                Registrations by Country
                            </h3>
                        </div>

                        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginBottom: "24px" }}>

                            <a
                                href="/your-medboard/country-registrations/product-registrations-country-totals/"
                                className="subtle-stat-box"
                                style={{ flex: 1, minWidth: "180px" }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <i className="fas fa-map-marked-alt" style={{ color: "#a0aec0", fontSize: "20px" }} />
                                    <span style={{ fontSize: "13px", fontWeight: 600, color: "#4a5568" }}>
                                        Global Activity
                                    </span>
                                </div>
                                <div style={{ fontSize: "18px", fontWeight: 700, color: "#777", marginTop: "8px" }}>
                                {dashboardData.TotalCountries || 0}
                                </div>
                            </a>

                            <a
                                href="/your-medboard/country-registrations/registrations/?filter[Selling]=1"
                                className="subtle-stat-box" style={{ flex: 1, minWidth: "180px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <i className="fas fa-globe" style={{ color: "#a0aec0", fontSize: "20px" }} />
                                    <span style={{ fontSize: "13px", fontWeight: 600, color: "#4a5568" }}>
                                        Active Countries
                                    </span>
                                </div>
                                <div style={{ fontSize: "18px", fontWeight: 700, color: "#777", marginTop: "8px" }}>
                                    {dashboardData.ActiveCountries || 0}
                                </div>
                        </a>
                        <a
                            href="/your-medboard/country-registrations/documents/"
                            className="subtle-stat-box" style={{ flex: 1, minWidth: "180px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <i className="fas fa-file" style={{ color: "#a0aec0", fontSize: "20px" }} />
                                <span style={{ fontSize: "13px", fontWeight: 600, color: "#4a5568" }}>
                                    Files
                                </span>
                            </div>
                            <div style={{ fontSize: "18px", fontWeight: 700, color: "#777", marginTop: "8px" }}>
                                {dashboardData.FilesCount || 0}
                            </div>
                        </a>
                             <a
                                href="/your-medboard/country-registrations/registrations/?filter[Selling]=1"
                                className="subtle-stat-box" style={{ flex: 1, minWidth: "180px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <i className="fas fa-shipping-fast" style={{ color: "#a0aec0", fontSize: "20px" }} />
                                    <span style={{ fontSize: "13px", fontWeight: 600, color: "#4a5568" }}>
                                        Ready to Ship
                                    </span>
                                </div>
                                <div style={{ fontSize: "18px", fontWeight: 700, color: "#777", marginTop: "8px" }}>
                                    {dashboardData.ProductsAbleToShip || 0}
                                </div>
                        </a>

                        </div>

                        {/* Map Container */}
                        <div id="country-registrations-world-map-graph-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", border: "2px dashed #e2e8f0", borderRadius: "8px", background: "#f7fafc", width: "100%", padding: "16px" }}>
                            <WorldRegistrationsMap legalManufacturerId={selectedManufacturer} />
                        </div>

                </div>

                <div style={{ flex: 1, minWidth: "350px", background: "#fff", borderRadius: "12px", padding: "24px", border: "1px solid #e2e8f0" }}>

                    <div style={{ marginBottom: "20px", borderBottom: "1px solid #edf2f7", paddingBottom: "12px" }}>

                        <h3 style={{ margin: 0, fontSize: "14px", fontWeight: 700 }}>
                            Registration Activity
                        </h3>

                    </div>

                    <a
                        href="/your-medboard/country-registrations/registrations/?filter[ExpirationLimit]=365"
                        className="subtle-alert-box"
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <i className="fas fa-exclamation-circle" style={{ color: "#dd6b20" }} />
                            <span style={{ fontSize: "13px", fontWeight: 600, color: "#c05621" }}>
                                Expiring &lt; 1 Year
                            </span>
                        </div>

                        <div style={{ fontSize: "18px", fontWeight: 700, color: "#dd6b20" }}>
                            {dashboardData.RegistrationsToBeExpiredCount}
                        </div>
                    </a>

                    <div id="all-products-status-countries-graph-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px", }}>

                        <ProductStatusColumnChart
                            legalManufacturerId={selectedManufacturer}
                            countryPageUrl="/your-medboard/country-registrations/registrations/"
                        />

                    </div>

                </div>

            </div>


            {/* OTHER GRAPHS */}

            <DashboardTrends legalManufacturerId={selectedManufacturer} />




        </div>

    )
}





const WorldRegistrationsMap = ({ legalManufacturerId }) => {

    const [options, setOptions] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (legalManufacturerId === undefined || legalManufacturerId === null) return

        const fetchData = async () => {

            setLoading(true)

            try {

                const res = await fetch(
                    `/umbraco/api/ProductRegistrationsApi/RegistrationCountriesStats?establishmentId=${legalManufacturerId}`
                )

                const data = await res.json()

                const groupedData = data.reduce((acc, item) => {
                    const key = item.countryCode?.trim().toLowerCase();
                    if (!key) return acc;

                    if (!acc[key]) {
                        acc[key] = {
                            "hc-key": key,
                            value: 0,
                            countryId: item.countryId,
                            countryName: item.countryName,
                            details: []
                        };
                    } else {
                        if (acc[key].countryName === 'European Union' && item.countryName !== 'European Union') {
                            acc[key].countryName = item.countryName;

                            if (item.countryId) {
                                acc[key].countryId = item.countryId;
                            }
                        }
                    }

                    acc[key].value += Number(item.value) || 0;
                    acc[key].details.push({
                        countryName: item.countryName,
                        value: Number(item.value) || 0
                    });

                    return acc;
                }, {});

                const mapData = Object.values(groupedData);

                setOptions({
                    chart: {
                        map: "custom/world",
                        backgroundColor: "transparent"
                    },

                    title: { text: null },

                    legend: {
                        title: { text: "Registrations" }
                    },

                    exporting: {
                        local: true,
                        libURL: "/assets/js/highcharts/libs/"
                    },

                    colorAxis: {
                        min: 0,
                        stops: [
                            [0, "#cce0ff"],
                            [0.5, "#7cb5ec"],
                            [1, "#003399"]
                        ]
                    },

                    mapNavigation: {
                        enabled: true,
                        enableMouseWheelZoom: true
                    },

                    tooltip: {
                        enabled: true,
                        useHTML: true,
                        formatter: function () {
                            if (!this.point) {
                                return ""
                            }

                            const pointTitle = this.point.countryName || this.point.name || this.point['hc-key'] || 'Region';

                            let tooltipHtml = '<span style="font-weight:600; font-size: 11px; padding-bottom:5px;">' + pointTitle + '</span><br/>'

                            if (this.point.details && this.point.details.length > 0) {
                                const isSingleDetail = this.point.details.length === 1;

                                this.point.details.sort((a, b) => b.value - a.value).forEach(detail => {
                                    const detailName = detail.countryName || '';
                                    const isMatch = detailName.includes(pointTitle) || pointTitle.includes(detailName);

                                    if (isSingleDetail && isMatch) {
                                        tooltipHtml += detail.value + ' registrations<br/>';
                                    } else {
                                        tooltipHtml += detailName + ': ' + detail.value + ' registrations<br/>';
                                    }
                                })
                            } else if (this.point.value !== undefined) {
                                tooltipHtml += 'Total: ' + this.point.value
                            }

                            return tooltipHtml
                        }
                    },

                    series: [
                        {
                            data: mapData,
                            name: "Registrations",
                            joinBy: "hc-key",

                            states: {
                                hover: {
                                    color: "#a4edba"
                                }
                            },

                            cursor: "pointer",

                            point: {
                                events: {
                                    click: function () {
                                        const isSingleDetail = this.details && this.details.length === 1;

                                        let targetCountryId = this.countryId;

                                        if (isSingleDetail && this.details[0]?.countryName === 'European Union') {
                                            targetCountryId = 2;
                                        }

                                        window.location.href = `/your-medboard/country-registrations/product-registration-country/?country=${targetCountryId}`;
                                    }
                                }
                            }
                        }
                    ],

                    credits: {
                        enabled: true,
                        text: "MedBoard",
                        href: "https://www.medboard.com",
                        mapText: null
                    }
                })

            } catch (err) {
                console.error(err)
            }

            setLoading(false)
        }

        fetchData()

    }, [legalManufacturerId])

    if (loading)
        return (
            <div style={{ textAlign: "center" }}>
                <img src="/assets/js/frontend/public/loading-spinner.gif" alt="loading" />
            </div>
        )

    if (!options)
        return null

    return (

        <div>
            <HighchartsReact
                highcharts={Highcharts}
                constructorType="mapChart"
                options={options}
            />
        </div>
    )
}





const ProductStatusColumnChart = ({ legalManufacturerId, countryPageUrl }) => {
    const [loading, setLoading] = useState(true);
    const [results, setResults] = useState([]);

    useEffect(() => {
        if (legalManufacturerId === undefined || legalManufacturerId === null) return;

        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(
                    `/umbraco/api/ProductRegistrationsApi/ProductRegistrationsStatusStats?establishmentId=${legalManufacturerId}`
                );
                const data = await res.json();

                const possibleColors = [
                    { statusId: 0, color: "#BFDDF3", borderColor: "#5B9BD5", textColor: "#000", backgroundColor: "#f8fafc"}, // blue
                    { statusId: 1, color: "#CFE9B8", borderColor: "#6FAE2D", textColor: "#000", backgroundColor: "#f8fafc" }, // green
                    { statusId: 2, color: "#F6C3BC", borderColor: "#D9534F", textColor: "#000", backgroundColor: "#f8fafc" }, // red
                    { statusId: 3, color: "#CFE9B8", borderColor: "#6FAE2D", textColor: "#000", backgroundColor: "#f8fafc" }, // green
                    { statusId: 4, color: "#CFE9B8", borderColor: "#6FAE2D", textColor: "#000", backgroundColor: "#f8fafc" }, // green
                    { statusId: 5, color: "#F6C3BC", borderColor: "#D9534F", textColor: "#000", backgroundColor: "#f8fafc" }, // red
                    { statusId: 6, color: "#E3E3E3", borderColor: "#9A9A9A", textColor: "#000", backgroundColor: "#f8fafc" }, // gray
                    { statusId: 7, color: "#BFDDF3", borderColor: "#5B9BD5", textColor: "#000", backgroundColor: "#f8fafc" }, // blue
                    { statusId: 8, color: "#D6D6D6", borderColor: "#4A4A4A", textColor: "#000", backgroundColor: "#f8fafc" }, // black/neutral
                    { statusId: 9, color: "#F8D2AF", borderColor: "#D9822B", textColor: "#000", backgroundColor: "#f8fafc" }, // orange
                ];

                let mappedResults = data.map(r => {
                    let pC = possibleColors.find(i => i.statusId == r.StatusId);
                    return {
                        ...r,
                        Color: pC?.color,
                        BorderColor: pC?.borderColor,
                        TextColor: pC?.textColor,
                        BackgroundColor: pC?.backgroundColor,
                    };
                });

                setResults(mappedResults);
            } catch (err) {
                console.error(err);
            }
            setLoading(false);
        };

        fetchData();
    }, [legalManufacturerId, countryPageUrl]);

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "20px" }}>
                <img src="/assets/js/frontend/public/loading-spinner.gif" alt="loading" />
            </div>
        );
    }

    return (
        <div style={{ width: "100%" }}>

            {results.map(status => (
                <a
                    key={status.StatusId}
                    href={`/your-medboard/country-registrations/registrations/?filter[Status]=${status.StatusId}`}
                    className="status-list-item"
                    style={{backgroundColor: status.BackgroundColor} }
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                            className="status-dot"
                            style={{ backgroundColor: status.BorderColor || "#cbd5e0" }}
                        />
                        <span style={{ fontSize: "13px", fontWeight: 600 }}>
                            {status.StatusName}
                        </span>
                    </div>

                    <strong style={{ fontSize: "15px", color: "#777" }}>
                        {status.Count}
                    </strong>
                </a>
            ))}
        </div>
    );
};



const TrendChart = ({ title, seriesName, color, icon, data, valueField }) => {
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const subCountColors = [
        "#3182ce", // New
        "#38a169", // Renewal
        "#dd6b20", // Change
        "#805ad5"  // Other
    ];

    const series =
        valueField === "SubCounts"
            ? (() => {
                  const types = data[0]?.SubCounts ?? [];

                  return types.map((type, index) => ({
                      name: type.Name,
                      data: data.map(month => {
                          const item = month.SubCounts.find(x => x.Type === type.Type);
                          return item?.Count ?? 0;
                      }),
                      color: subCountColors[index % subCountColors.length]
                  }));
              })()
            : [{
                  name: seriesName,
                  data: data.map(x => x[valueField]),
                  color
              }];

    const options = {
        chart: {
            type: "areaspline",
            backgroundColor: "transparent",
            height: 120,
            spacing: [0, 0, 0, 0]
        },

        title: {
            text: null
        },

        credits: {
            enabled: false
        },

        exporting: {
            enabled: false
        },

        legend: {
            enabled: valueField === "SubCounts"
        },

        xAxis: {
            categories: data.map(x => monthNames[x.Month - 1]),
            lineWidth: 0,
            tickLength: 0,
            labels: {
                style: {
                    color: "#a0aec0",
                    fontSize: "11px",
                    fontWeight: "600"
                }
            }
        },

        yAxis: {
            title: {
                text: null
            },
            allowDecimals: false,
            gridLineColor: "#edf2f7",
            labels: {
                enabled: true,
                style: {
                    color: "#a0aec0",
                    fontSize: "11px",
                    fontWeight: "600"
                }
            }
        },

        tooltip: {
            shared: true
        },

        plotOptions: {
            series: {
                animation: true,
                marker: {
                    enabled: true,
                    radius: 5,
                    fillColor: "#fff",
                    lineWidth: 2,
                    lineColor: null // Uses the series color
                }
            },

            areaspline: {
                lineWidth: 3,
                fillOpacity: valueField === "SubCounts" ? 0.05 : 0.15
            }
        },

        series
    };

    return (
        <div
            className="chart-panel"
            style={{ padding: "20px" }}
        >
            <div
                className="panel-header"
                style={{
                    marginBottom: "16px",
                    paddingBottom: "10px"
                }}
            >
                <h3
                    className="panel-title"
                    style={{
                        color: "#4a5568",
                        fontSize: "13px"
                    }}
                >
                    <i
                        className={icon}
                        style={{
                            marginRight: "6px",
                            color
                        }}
                    />
                    {title}
                </h3>
            </div>

            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    );
};


const DashboardTrends = ({ legalManufacturerId }) => {
    const [loading, setLoading] = useState(true);
    const [trendData, setTrendData] = useState([]);

    useEffect(() => {
        if (legalManufacturerId == null) return;

        const fetchData = async () => {
            setLoading(true);

            try {
                const url = "/umbraco/api/RIMSRegistrations/TrendLines/?establishmentId=" + legalManufacturerId;
                const res = await fetch(url);
                const data = await res.json();

                //data = [{"Year": 2026,"Month": 7,"SubCounts": [{"Type": 0,"Name": "New","Count": 0},{"Type": 1,"Name": "Renewal","Count": 0},{"Type": 2,"Name": "Change","Count": 0},{"Type": 3,"Name": "Other","Count": 0}],"RegCount": 0,"CertCount": 0},{"Year": 2026,"Month": 8,"SubCounts": [{"Type": 0,"Name": "New","Count": 2},{"Type": 1,"Name": "Renewal","Count": 3},{"Type": 2,"Name": "Change","Count": 4},{"Type": 3,"Name": "Other","Count": 5}],"RegCount": 2,"CertCount": 7},{"Year": 2026,"Month": 9,"SubCounts": [{"Type": 0,"Name": "New","Count": 6},{"Type": 1,"Name": "Renewal","Count": 8},{"Type": 2,"Name": "Change","Count": 6},{"Type": 3,"Name": "Other","Count": 15}],"RegCount": 2,"CertCount": 7}];

                setTrendData(data);
            } catch (err) {
                console.error(err);
            }

            setLoading(false);
        };

        fetchData();
    }, [legalManufacturerId]);

    if (loading) {
        return (
            <div style={{ textAlign: "center" }}>
                <img
                    src="/assets/js/frontend/public/loading-spinner.gif"
                    alt="loading"
                />
            </div>
        );
    }

    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "24px",
                marginBottom: "24px"
            }}
        >
            <TrendChart
                title="Total Registrations"
                color="#3182ce"
                icon="fas fa-chart-line"
                data={trendData}
                valueField="RegCount"
                seriesName="Registrations"
            />

            <TrendChart
                title="Total Certificates"
                color="#48bb78"
                icon="fas fa-chart-area"
                data={trendData}
                valueField="CertCount"
                seriesName="Certificates"
            />

            <TrendChart
                title="Total Open Submissions"
                color="#805ad5"
                icon="fas fa-wave-square"
                data={trendData}
                valueField="SubCounts"
                seriesName="Submissions"
            />
        </div>
    );
};




export default CountryRegistrationsDashboard;